// Modules
import { numberOfMonths } from "../premmio/public/modules/dateRange/dateRange.js";
import { months } from "../premmio/public/modules/months/months.js";
import { xhr } from "../premmio/public/modules/xhr/xhr.js";

// Components
import { Slider } from "../premmio/public/components/slider/slider.html.js";
import { ResponsiveImg } from "../premmio/public/components/responsiveImg/responsiveImg.html.js";
import { addEventDelegate } from "../premmio/public/modules/eventDelegate/eventDelegate.js";

// Elements
import {
  A,
  Button,
  H2,
  H3,
  Img,
  P,
  Section,
  Span,
  Stylesheet,
} from "../premmio/htmljs/elements.html.js";

import HTMLJS from "../premmio/htmljs/html.js";

const App = new HTMLJS();

// add the style to the head
App.render(
  new Stylesheet(
    "https://justrollwithit.premm.io/styles/pages/fanart/fanart.css"
  ),
  null,
  (element) => {
    // append it to the head
    document.head.appendChild(element);
  }
);

/**
 * Generates the months elements.
 *
 * @returns {Array} The array of month elements.
 */
const generateMonths = () => {
  const elements = [];

  // start date
  const start = new Date("09/01/2023"),
    now = new Date(),
    // get the number of months between now and the start date
    monthCount = numberOfMonths(start, now);

  // now loop through the number of months
  let activeMonth = start.getMonth(),
    activeYear = start.getFullYear();

  for (let i = 0; i <= monthCount; i++) {
    // create a new month element
    elements.unshift(
      new H2({
        "data-month": activeMonth,
        "data-year": activeYear,
        children: [months[activeMonth], new Span({ textContent: activeYear })],
      })
    );

    // and change the activeMonth
    if (activeMonth === 11) {
      activeMonth = 0;
      activeYear++;
    } else {
      activeMonth++;
    }
  }

  return elements;
};

const data = new Section({
  id: "fanart",
  style: {
    margin: "-5rem -2rem 0 -2rem",
    overflow: "hidden",
  },
  children: [
    {
      children: [
        Slider({
          elements: generateMonths(),
          className: "fanart-months default",
        }),
        {
          id: "fanartContainer",
          children: (data) => {
            const { submissions } = data;

            const urlProtocol = (str) => {
              // if the string doesn't have a http:// or https:// prefix, add it
              if (!str.includes("http")) {
                return `https://${str}`;
              } else {
                return str;
              }
            };

            if (submissions.length === 0) {
              return [
                {
                  class: "no-submissions",
                  children: [
                    new P({
                      textContent: "No fanart submissions for this month.",
                    }),
                    new P([
                      "Why not ",
                      new A({
                        href: "/fanart-submit",
                        textContent: "submit your own",
                      }),
                      "?",
                    ]),
                  ],
                },
              ];
            }

            return submissions.map((submission) => {
              return {
                class: "submission",
                children: [
                  new Button({
                    "data-src": submission.srcs.src,
                    child: new ResponsiveImg({
                      alt: submission.title,
                      ...submission.srcs,
                    }),
                  }),
                  new H3(submission.title),
                  new A({
                    if: submission.url,
                    href: urlProtocol(submission.url),
                    target: "_blank",
                    textContent: submission.artist,
                  }),
                  new Span({
                    if: !submission.url,
                    textContent: submission.artist,
                  }),
                ],
              };
            });
          },
        },
        {
          class: "shadowbox",
          children: [
            new Button({
              class: "close",
              "aria-label": "Close",
            }),
            new Img(),
          ],
        },
      ],
    },
  ],
});

let rendered = false;

const fetchFanart = (month, year) => {
  const success = (request) => {
    const response = JSON.parse(request.response);

    const fanartData = {
      _id: "fanartData",
      month,
      year,
      submissions: response,
    };

    if (!rendered) {
      App.create(data, fanartData, (element) => {
        const fanart = document.querySelector("#fanart");

        fanart.replaceWith(element);
      });

      rendered = true;
    } else {
      App.update(fanartData);
    }
  };

  xhr({
    path: "https://justrollwithit.premm.io/fanart/retrieve",
    body: { month, year },
    success,
  });
};

const extractMonthAndYear = (slide) => {
  if (slide.dataset.state === "active") {
    const monthHeading = slide.querySelector("h2"),
      month = monthHeading.dataset.month,
      year = monthHeading.dataset.year;

    fetchFanart(month, year);
  }
};

addEventDelegate(
  "attributes:data-state",
  ".fanart-months .slide",
  extractMonthAndYear
);

const openShadowbox = (button) => {
  const src = button.dataset.src;

  const shadowbox = document.querySelector(".shadowbox"),
    image = shadowbox.querySelector("img");

  image.src = src;
  shadowbox.classList.add("active");
};

addEventDelegate("click", ".submission button", openShadowbox);

const closeShadowbox = () => {
  const shadowbox = document.querySelector(".shadowbox"),
    image = shadowbox.querySelector("img");

  image.src = "";
  shadowbox.classList.remove("active");
};

addEventDelegate("click", ".shadowbox .close, .shadowbox img", closeShadowbox);

// get the current month and year, and fetch the fanart
const currentMonth = new Date().getMonth(),
  currentYear = new Date().getFullYear();

fetchFanart(currentMonth, currentYear);
